import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = {
  key: 2,
  class: "p-fluid mb-4"
}
const _hoisted_6 = {
  key: 3,
  class: "w-12 lg:w-3"
}
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = {
  key: 4,
  class: "mt-4"
}
const _hoisted_10 = { class: "mb-2 font-bold" }
const _hoisted_11 = { class: "w-12 lg:w-3" }
const _hoisted_12 = { class: "p-fluid" }
const _hoisted_13 = { class: "px-2 py-2 bg-black-alpha-80 border-round-lg" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 5,
  class: "mt-4"
}
const _hoisted_17 = { class: "mb-2 font-bold" }
const _hoisted_18 = { class: "px-2 py-2 overflow-scroll bg-black-alpha-80 border-round-lg" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "mt-2" }
const _hoisted_21 = {
  key: 6,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPark = _resolveComponent("IconPark")!
  const _component_FieldTextarea = _resolveComponent("FieldTextarea")!
  const _component_FieldDropdownNext = _resolveComponent("FieldDropdownNext")!
  const _component_FieldDropdown = _resolveComponent("FieldDropdown")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showCompiledName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.showCompiledNameAsLink)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: `/endpoints/${_ctx.endpoint.id}`,
                target: "_blank"
              }, _toDisplayString(_ctx.endpoint.compiled_name), 9, _hoisted_2))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.endpoint.compiled_name), 1)
              ], 64)),
          _createVNode(_component_IconPark, {
            class: "ml-1 cursor-pointer",
            type: "copy",
            theme: "outline",
            size: "11",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboard(_ctx.endpoint.compiled_name)))
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.showUuid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[8] || (_cache[8] = _createElementVNode("div", null, "UUID:", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.endpoint.uuid), 1),
            _createVNode(_component_IconPark, {
              class: "ml-1 cursor-pointer",
              type: "copy",
              theme: "outline",
              size: "11",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyToClipboard(_ctx.endpoint.uuid)))
            })
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", null, "UID:", -1)),
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_ctx.endpoint.uid), 1),
            _createVNode(_component_IconPark, {
              class: "ml-1 cursor-pointer",
              type: "copy",
              theme: "outline",
              size: "11",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyToClipboard(_ctx.endpoint.uid)))
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.endpoint.protocol !== _ctx.PROTOCOL_DIRECT_LINK)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_FieldTextarea, {
            "model-value": _ctx.endpointURL,
            label: _ctx.$t('url'),
            rows: 2,
            disabled: ""
          }, null, 8, ["model-value", "label"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.endpoint.protocol === _ctx.PROTOCOL_DIRECT_LINK)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_FieldDropdownNext, {
              modelValue: _ctx.directlinkSelectedHost,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.directlinkSelectedHost) = $event)),
              label: "Direct Link Domain",
              options: _ctx.directlinkHostsOptions
            }, null, 8, ["modelValue", "options"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_FieldTextarea, {
        "model-value": _ctx.endpointURLExample,
        label: _ctx.endpoint.protocol === _ctx.PROTOCOL_DIRECT_LINK ? 'Direct Link URL' : _ctx.$t('url_example'),
        rows: 2,
        disabled: ""
      }, null, 8, ["model-value", "label"])
    ]),
    (_ctx.endpoint.protocol === _ctx.PROTOCOL_DIRECT_LINK)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"mb-4\"><div class=\"mb-2 font-bold\">Available URL params</div><div class=\"mb-2\">bidfloor<span class=\"ml-2 text-indigo-300\">float; default: 0.0</span><span class=\"ml-2\">Minimum bid for this impression expressed in CPM, example: &amp;bidfloor=0.5</span></div></div>", 1)),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('pop_code')), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_FieldDropdown, {
                modelValue: _ctx.popCodeMode,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.popCodeMode) = $event)),
                label: _ctx.$t('mode'),
                options: _ctx.popCodeModes,
                "option-label": "label",
                "option-label-translate": false
              }, null, 8, ["modelValue", "label", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("code", {
              class: "block w-full tab-size-4 white-space-pre-wrap cursor-pointer",
              innerHTML: _ctx.popCodeHeightlighted,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.copyToClipboard(_ctx.popCode)))
            }, null, 8, _hoisted_14), [
              [
                _directive_tooltip,
                _ctx.$t('copy'),
                void 0,
                { top: true }
              ]
            ])
          ]),
          _createElementVNode("div", {
            class: "py-2",
            innerHTML: _ctx.$t('data_elements_selectors_help')
          }, null, 8, _hoisted_15)
        ]))
      : _createCommentVNode("", true),
    (!!_ctx.endpoint.site_id && _ctx.endpoint.traffic_type === _ctx.TRAFFIC_TYPE_PUSH)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('push_code')) + ":", 1),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mb-2" }, "1. Place this code inside the \"head\" section of your website:", -1)),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("code", {
              class: "block w-full tab-size-4 white-space-pre-wrap cursor-pointer",
              innerHTML: _ctx.pushCodeHeightlighted,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.copyToClipboard(_ctx.pushCode)))
            }, null, 8, _hoisted_19), [
              [
                _directive_tooltip,
                _ctx.$t('copy'),
                void 0,
                { top: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mb-2" }, "2. Download & place our Service Worker file inside the root directory of your website ⚠️", -1)),
            _createElementVNode("a", {
              class: "block",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.downloadPushServiceWorker && _ctx.downloadPushServiceWorker(...args)))
            }, "Download Service Worker")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showComment && _ctx.endpoint.comment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('comment')) + ":", 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.endpoint.comment), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}